module.exports = __webpack_public_path__ + "img/eth-bg.9e329109.svg";